import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { EmptyState, ErrorState } from "@/components/empty-state";

export const Route = createFileRoute("/admin/games")({
  component: AdminGames,
});

function AdminGames() {
  const q = useQuery({ queryKey: ["admin-games-list"], queryFn: () => api.games({ limit: 60 }) });

  return (
    <div>
      <header className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="font-display text-2xl font-bold">Games</h1>
          <p className="text-sm text-muted-foreground">Imported games are managed here. New games appear after Steam imports.</p>
        </div>
      </header>
      {q.isError && <ErrorState message={(q.error as Error).message} />}
      {q.isSuccess && q.data.data.length === 0 && (
        <EmptyState title="No games yet" description="Start a Steam import from the Steam import page." />
      )}
      {q.isSuccess && q.data.data.length > 0 && (
        <div className="overflow-x-auto rounded-xl border border-border bg-card">
          <table className="w-full text-sm">
            <thead className="bg-surface text-left text-xs uppercase tracking-wider text-muted-foreground">
              <tr>
                <th className="px-4 py-3">Title</th>
                <th className="px-4 py-3">Slug</th>
                <th className="px-4 py-3">Steam ID</th>
                <th className="px-4 py-3 text-right">Steam price</th>
              </tr>
            </thead>
            <tbody>
              {q.data.data.map((g) => (
                <tr key={g.id} className="border-t border-border/60">
                  <td className="px-4 py-2">{g.title}</td>
                  <td className="px-4 py-2 text-muted-foreground">{g.slug}</td>
                  <td className="px-4 py-2 text-muted-foreground">{g.steamAppid ?? "—"}</td>
                  <td className="px-4 py-2 text-right">{g.steamPriceFinal != null ? `${(g.steamPriceFinal / 100).toFixed(2)} ${g.steamCurrency}` : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
